import { FormField, FormResponseValue } from "@tellescope/types-models";
import { resolveFieldOptionDetails } from "./resolve-field-option-details";
import { resolveVisibleChoices } from "./resolve-visible-choices";
import { NextFieldLogicOptions } from "./types";

type ResponseMap = Record<string, FormResponseValue>;

export const dropStaleChoiceSelections = ({
  responses,
  fieldsArr,
  changedFieldId,
  logicOptions,
}: {
  responses: ResponseMap;
  fieldsArr: FormField[];
  changedFieldId: string;
  logicOptions?: NextFieldLogicOptions;
}): ResponseMap => {
  const responsesArr = Object.values(responses);

  return fieldsArr.reduce((acc, field) => {
    if (field.id === changedFieldId) return acc;
    if (field.type !== "multiple_choice" && field.type !== "Dropdown") return acc;

    const response = acc[field.id];
    if (response?.answer.type !== "multiple_choice" && response?.answer.type !== "Dropdown") return acc;
    const selected = response.answer.value;
    if (!Array.isArray(selected) || !selected.length) return acc;

    const optionDetails = resolveFieldOptionDetails(field.options);
    if (!optionDetails.some((option) => option.showCondition)) return acc;

    const visible = resolveVisibleChoices({ optionDetails, responses: responsesArr, logicOptions }).map(
      (option) => option.option
    );
    const allChoices = optionDetails.map((option) => option.option);
    // A value that is not one of the field's choices is the free-text "other" answer, which
    // survives regardless of which choices are currently visible.
    const kept = selected.filter((v) => !allChoices.includes(v) || visible.includes(v));
    if (kept.length === selected.length) return acc;

    const updated: FormResponseValue = { ...response, answer: { ...response.answer, value: kept } };
    return { ...acc, [field.id]: updated };
  }, responses);
};
